/**
 * 画面に近づいた動画だけ再生する（2026-09-24・表示速度の改善）。
 * snippets/sekka-video-light.liquid が出す [data-sk-lazyvideo] が対象。
 * preload="none" なので、再生を始めるまで動画の本体は1バイトも落ちてこない。
 * 画面から外れたら止める（横スクロールの列で見えていない動画を回し続けない）。
 */
(function () {
  if (window.__skLazyVideo) return;
  window.__skLazyVideo = true;

  function showPoster(v) {
    var src = v.getAttribute('data-poster');
    if (src) {
      v.poster = src;
      v.removeAttribute('data-poster');
    }
  }

  function play(v) {
    showPoster(v);
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function init() {
    var vids = document.querySelectorAll('video[data-sk-lazyvideo]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < vids.length; i++) play(vids[i]);
      return;
    }
    // ポスター画像は少し早め（画面の600px手前）に読んでおき、再生は200px手前から
    var posterIo = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          showPoster(entries[i].target);
          posterIo.unobserve(entries[i].target);
        }
      },
      { rootMargin: '600px 600px' }
    );
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var v = entries[i].target;
          if (entries[i].isIntersecting) play(v);
          else if (!v.paused) v.pause();
        }
      },
      { rootMargin: '200px 0px' }
    );
    for (var j = 0; j < vids.length; j++) {
      posterIo.observe(vids[j]);
      io.observe(vids[j]);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
